import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      {/* Hero */}
      <header className="bg-white dark:bg-zinc-800 rounded-3xl p-12 md:p-20 text-center shadow-lg transition-colors">
        <h1 className="text-4xl md:text-6xl font-black text-slate-900 dark:text-white mb-6">
          Transporte ohne Leerfahrten
        </h1>
        <p className="text-xl text-slate-600 dark:text-slate-300 max-w-2xl mx-auto mb-10">
          Zero-Job bringt Versender und Transportunternehmer direkt zusammen. Kostenlos für Privatpersonen. Fair für Profis.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-4">
          <Link to="/fracht" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-bold transition">
            📦 Fracht einstellen
          </Link>
          <Link to="/leerfahrten" className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-bold transition">
            🚚 Leerfahrt anbieten
          </Link>
        </div>
      </header>

      {/* Features */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <div className="bg-white dark:bg-zinc-800 p-8 rounded-2xl shadow-md border border-slate-100 dark:border-zinc-700 hover:-translate-y-1 transition-all">
          <div className="text-3xl mb-4">🚚</div>
          <h3 className="text-xl font-bold mb-2">Für Fahrer</h3>
          <p className="text-slate-500 dark:text-slate-300 text-sm">
            Finde passende Frachten in deiner Nähe und maximiere deine Auslastung.
          </p>
        </div>
        <div className="bg-white dark:bg-zinc-800 p-8 rounded-2xl shadow-md border border-slate-100 dark:border-zinc-700 hover:-translate-y-1 transition-all">
          <div className="text-3xl mb-4">📦</div>
          <h3 className="text-xl font-bold mb-2">Für Versender</h3>
          <p className="text-slate-500 dark:text-slate-300 text-sm">
            Stelle deine Sendungen online und erhalte Angebote von geprüften Partnern.
          </p>
        </div>
        <div className="bg-white dark:bg-zinc-800 p-8 rounded-2xl shadow-md border border-slate-100 dark:border-zinc-700 hover:-translate-y-1 transition-all">
          <div className="text-3xl mb-4">🛡️</div>
          <h3 className="text-xl font-bold mb-2">Sicher & Schnell</h3>
          <p className="text-slate-500 dark:text-slate-300 text-sm">
            Direkte Kommunikation und transparente Abwicklung ohne Umwege.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
